/**
 * Axios設定
 * UNIFIED_DEVELOPMENT_GUIDE準拠
 */

import Axios from 'axios';

const axios = Axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/',
  withCredentials: true, // Cookie認証用
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
axios.interceptors.request.use(
  (config) => {
    // FormDataの場合はContent-Typeを削除（ブラウザが自動設定）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    // トークンがある場合は付与
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 401エラーの場合
    if (error.response?.status === 401) {
      // トークンをクリア
      localStorage.removeItem('auth_token');
      
      // ログインページへリダイレクト（ログインページ自体では実行しない）
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;